import { Menu, MenuPopupBody } from '@/popups/menupopup/menu'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'

export interface SimpleCard {
  userId: string
  username: string
  ucid: string
  createdAt: string
}

export const extendCommunalCardsMenuPopup = ({ menu, services, session, row, navigate }: {
    menu: Menu
    services: Services
    session: CurrentSession
    row: SimpleCard
    navigate: (url: string) => void
}): Menu => {
    return menu
}